// @flow

import * as React from 'react';
import { toast } from 'react-toastify';
import deepEqual from 'deep-equal';

import type { ActionStatus } from '../types';

type Props = {
  moduleName?: string,
  saveStatus: string,
  orderActiveStatus?: ActionStatus,
  orderCreateStatus?: ActionStatus,
  orderRemoveStatus?: ActionStatus,
  itemAddedStatus?: ActionStatus,
};

export default class Notifications extends React.Component<Props> {
  toastId = null;

  shouldComponentUpdate(nextProps: Props) {
    if (deepEqual(nextProps, this.props)) {
      return false;
    }

    return true;
  }

  componentDidUpdate(prevProps: Props) {
    if (toast.isActive(this.toastId)) {
      return;
    }

    // NOTE: disabling all notifications
    // if (prevProps.saveStatus === 'error') {
    //   this.toastId = toast(
    //     messages.common.saveStatusError,
    //     notificationsConfig.error,
    //   );
    // } else if (prevProps.saveStatus === 'saved') {
    //   this.toastId = toast(
    //     messages.common.saveStatusSuccess,
    //     notificationsConfig.success,
    //   );
    // }

    // if (prevProps.orderCreateStatus === 'error') {
    //   if (this.props.moduleName === 'order') {
    //     this.toastId = toast(
    //       messages.editOrderNotes.fail,
    //       notificationsConfig.error,
    //     );
    //   } else {
    //     this.toastId = toast(
    //       messages.createOrder.fail,
    //       notificationsConfig.error,
    //     );
    //   }
    // } else if (prevProps.orderCreateStatus === 'completed') {
    //   if (this.props.moduleName === 'order') {
    //     this.toastId = toast(
    //       messages.editOrderNotes.success,
    //       notificationsConfig.success,
    //     );
    //   } else {
    //     this.toastId = toast(
    //       messages.createOrder.success,
    //       notificationsConfig.success,
    //     );
    //   }
    // }

    // if (prevProps.itemAddedStatus === 'error') {
    //   if (this.props.moduleName === 'order') {
    //     this.toastId = toast(
    //       messages.addItemToOrder.editFail,
    //       notificationsConfig.error,
    //     );
    //   } else {
    //     this.toastId = toast(
    //       messages.addItemToOrder.fail,
    //       notificationsConfig.error,
    //     );
    //   }
    // } else if (prevProps.itemAddedStatus === 'completed') {
    //   if (this.props.moduleName === 'order') {
    //     this.toastId = toast(
    //       messages.addItemToOrder.editSuccess,
    //       notificationsConfig.success,
    //     );
    //   } else {
    //     this.toastId = toast(
    //       messages.addItemToOrder.success,
    //       notificationsConfig.success,
    //     );
    //   }
    // }

    // if (prevProps.orderActiveStatus === 'error') {
    //   this.toastId = toast(
    //     messages.activeOrder.fail,
    //     notificationsConfig.error,
    //   );
    // } else if (prevProps.orderActiveStatus === 'completed') {
    //   this.toastId = toast(
    //     messages.activeOrder.success,
    //     notificationsConfig.success,
    //   );
    // }

    // if (prevProps.orderRemoveStatus === 'error') {
    //   this.toastId = toast(
    //     messages.removeOrder.fail,
    //     notificationsConfig.error,
    //   );
    // } else if (prevProps.orderRemoveStatus === 'completed') {
    //   this.toastId = toast(
    //     messages.removeOrder.success,
    //     notificationsConfig.success,
    //   );
    // }
  }

  render() {
    return null;
  }
}
